export enum NuxtEvents {
  ChangeLanguage = 'language:change',
}
